export default "__VITE_ASSET__q0jaEDuc__"